import React from 'react';
import { Link } from 'react-router-dom';
import PageTemplate from '../components/PageTemplate';

const BlogPage = () => {
  const blogPosts = [
    {
      id: 1,
      title: 'How to Prepare for Your First Specialist Appointment',
      excerpt: 'Being referred to a specialist can be intimidating. Learn how to prepare effectively to make the most of your visit.',
      author: 'Dr. Sarah Johnson',
      date: 'April 2, 2025',
      category: 'Patient Tips',
      image: '/images/blog/specialist-appointment.jpg'
    },
    {
      id: 2,
      title: 'Understanding Your Medical Test Results',
      excerpt: 'Medical test results can be confusing. This guide helps you understand common tests and what their results might mean.',
      author: 'Dr. James Wilson',
      date: 'March 28, 2025',
      category: 'Health Education',
      image: '/images/blog/medical-tests.jpg'
    },
    {
      id: 3,
      title: 'The Importance of Medical History in Diagnosis',
      excerpt: 'Your medical history provides crucial context for healthcare providers. Learn why it is so important and how to present it effectively.',
      author: 'Emily Rodriguez',
      date: 'March 15, 2025',
      category: 'Healthcare Insights',
      image: '/images/blog/medical-history.jpg'
    },
    {
      id: 4,
      title: '5 Questions You Should Always Ask Your Doctor',
      excerpt: 'Make the most of your doctor visit by asking these five essential questions during your appointment.',
      author: 'Patricia Nguyen',
      date: 'March 10, 2025',
      category: 'Patient Tips',
      image: '/images/blog/doctor-questions.jpg'
    },
    {
      id: 5,
      title: 'How AI is Transforming Patient Care',
      excerpt: 'Artificial intelligence is changing healthcare in numerous ways. Discover how AI tools like Patients Empowered Coach are empowering patients.',
      author: 'Michael Chen',
      date: 'February 28, 2025',
      category: 'Technology',
      image: '/images/blog/ai-healthcare.jpg'
    },
    {
      id: 6,
      title: 'Managing Chronic Conditions: A Comprehensive Guide',
      excerpt: 'Living with a chronic condition requires ongoing care and attention. This guide provides strategies for effective management.',
      author: 'Dr. Robert Thompson',
      date: 'February 15, 2025',
      category: 'Health Management',
      image: '/images/blog/chronic-conditions.jpg'
    }
  ];

  const categories = [
    'All Categories',
    'Patient Tips',
    'Health Education',
    'Healthcare Insights',
    'Technology',
    'Health Management'
  ];

  return (
    <PageTemplate
      title="Blog"
      heroDescription="Insights and advice to help you navigate your healthcare journey"
    >
      <div className="grid grid-cols-1 grid-lg-cols-4 gap-lg">
        <div className="grid-lg-cols-3">
          <div className="mb-5">
            <input
              type="text"
              placeholder="Search articles..."
              className="form-control"
            />
          </div>

          <div className="grid grid-cols-1 gap-lg">
            {blogPosts.map(post => (
              <article key={post.id} className="card">
                <div
                  className="mb-3"
                  style={{
                    height: '100px',
                    backgroundImage: `url(${post.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    borderRadius: 'var(--radius-md)'
                  }}
                />
                <div className="mb-2">
                  <span className="badge badge-primary">{post.category}</span>
                  <span className="text-muted text-sm ml-2">{post.date}</span>
                </div>
                <h3 className="mb-2">{post.title}</h3>
                <p className="mb-3">{post.excerpt}</p>
                <div className="flex justify-between items-center">
                  <span className="text-sm">By {post.author}</span>
                  <Link to={`/blog/${post.id}`} className="btn btn-secondary btn-sm">Read More</Link>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-4 mb-5">
            <nav aria-label="Blog pagination">
              <ul className="flex justify-center gap-sm">
                <li><button className="btn btn-secondary btn-sm">Previous</button></li>
                <li><button className="btn btn-primary btn-sm">1</button></li>
                <li><button className="btn btn-secondary btn-sm">2</button></li>
                <li><button className="btn btn-secondary btn-sm">3</button></li>
                <li><button className="btn btn-secondary btn-sm">Next</button></li>
              </ul>
            </nav>
          </div>
        </div>

        <div>
          <div className="card mb-4">
            <h3 className="mb-3">Categories</h3>
            <ul className="mb-0">
              {categories.map((category, index) => (
                <li key={index} className="mb-2">
                  <button className={`text-left ${index === 0 ? 'font-bold' : ''}`}>{category}</button>
                </li>
              ))}
            </ul>
          </div>

          <div className="card mb-4">
            <h3 className="mb-3">Popular Posts</h3>
            <ul className="mb-0">
              {blogPosts.slice(0, 3).map(post => (
                <li key={post.id} className="mb-3">
                  <Link to={`/blog/${post.id}`} className="flex gap-sm">
                    <div
                      style={{
                        width: '150px',
                        height: '100px',
                        backgroundImage: `url(${post.image})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: 'var(--radius-sm)',
                        flexShrink: 0
                      }}
                    />
                    <div>
                      <h4 className="text-sm mb-1">{post.title}</h4>
                      <span className="text-muted text-sm">{post.date}</span>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="card">
            <h3 className="mb-3">Subscribe to Our Newsletter</h3>
            <p className="mb-3">Stay updated with our latest articles and health tips.</p>
            <input
              type="email"
              placeholder="Your email address"
              className="form-control mb-3"
            />
            <button className="btn btn-primary btn-block">Subscribe</button>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default BlogPage;
